const gallery = () => import(/* webpackChunkName: "gallery" */ '@/views/page/gallery/index.vue');

const analysis = () => import(/* webpackChunkName: "gallery" */ '@/views/page/gallery/analysis.vue');
const comment = () => import(/* webpackChunkName: "gallery" */ '@/views/page/gallery/comment.vue');
const guessing = () => import(/* webpackChunkName: "gallery" */ '@/views/page/gallery/guessing.vue');
const moreType = () => import(/* webpackChunkName: "gallery" */ '@/views/page/gallery/moreType.vue');
const details = () => import(/* webpackChunkName: "gallery" */ '@/views/page/gallery/details.vue');
const jingDetails = () => import(/* webpackChunkName: "gallery" */ '@/views/page/gallery/jingDetails.vue')
const VotRecord = () => import(/* webpackChunkName: "gallery" */ '@/views/page/gallery/VotRecord.vue')

const galleryRoute = [
    {
        path: '/gallery',
        name: 'gallery',
        component: gallery,
        meta: {
            keepAlive: true,
            top:true,
        },
    },
    {
        path: '/gallery/analysis',
        name: 'analysis',
        component: analysis,
        meta: {
            top:true
        },
        
    },
    {
        path: '/gallery/analysis/comment',
        name: 'comments',
        component: comment
    },
    {
        path: '/gallery/analysis/guessing',
        name: 'guessing',
        component: guessing,
        meta:{
            needLogin: true,
            top:true
        }
    },
    {
        path: '/gallery/analysis/guessing/more',
        name: 'moreType',
        component: moreType
    },
    {
        path: '/gallery/analysis/details',
        name: 'galleryDetails',
        component: details,
        meta: {
            top:true
        },
    },
    {
        path: '/gallery/guess/details',
        name: 'jingDetails',
        component: jingDetails,
        meta: {
            top:true
        },
    },
    {
        path: '/gallery/guess/VotRecord',
        name: 'VotRecord',
        component: VotRecord
    },
    
    
]

export default galleryRoute
